import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { DarkModeContext } from "../../context/DarkModeContext";
import { getToken } from "../../utils/auth";
import BienvenidoAdmin from "../../components/administracion/BienvenidoAdmin";
import TablaRubrosAdmin from "../../components/administracion/TablaRubrosAdmin";
import TituloPagina from "../../components/comunes/TituloPagina";
import Footer from "../../components/comunes/Footer";

const AdminRubros = () => {
  const { darkMode } = useContext(DarkModeContext);
  const navigate = useNavigate();

  useEffect(() => {
    const verificar = async () => {
      const token = getToken();
      try {
        if (!token) throw new Error("Sin sesión");
        const response = await fetch(process.env.REACT_APP_API_TOKEN, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ Token: token }),
        });
        if (!response.ok || (await response.json()) !== 8) throw new Error("Sin acceso");
      } catch {
        sessionStorage.removeItem("token");
        await Swal.fire({
          title: "Sesión expirada o acceso no autorizado.", confirmButtonText: "Ok",
          customClass: { container: darkMode ? "swal2-container--dark" : "swal2-container--light", confirmButton: "my-swal-button" },
        });
        navigate("/");
      }
    };
    verificar();
  }, [darkMode, navigate]);

  return (
    <div className="d-flex flex-column min-vh-100" translate="no">
      <div className="pt-5"><BienvenidoAdmin /></div>
      <TituloPagina title="Rubros F.883" />
      <TablaRubrosAdmin />
      <div className="py-4 mt-auto"><Footer /></div>
    </div>
  );
};

export default AdminRubros;
